import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, catchError, map, mergeMap } from 'rxjs';
import { lessonsActions } from '../actions/lessons.actions';
import { HttpService } from '../services/http.service';
import { finalizeLoader } from '@app/shared/components';

@Injectable()
export class LessonsEffects {
    private readonly actions = inject(Actions);
    private readonly httpService = inject(HttpService);

    getLessons$ = createEffect(() => {
        return this.actions.pipe(
            ofType(lessonsActions.getLessons),
            mergeMap(({ value }) => {
                return this.httpService.getLessons(value).pipe(
                    finalizeLoader('lessons-list'),
                    map(({ payload, total }) => lessonsActions.getLessonsSuccess({ payload, total })),
                    catchError((response: HttpErrorResponse) => of(lessonsActions.getLessonsError({ code: response.status }))),
                );
            }),
        );
    });
}
